import { render, staticRenderFns } from "./WarehouseDetails.vue?vue&type=template&id=fd5c2c6c&scoped=true"
import script from "./WarehouseDetails.vue?vue&type=script&lang=js"
export * from "./WarehouseDetails.vue?vue&type=script&lang=js"
import style0 from "./WarehouseDetails.vue?vue&type=style&index=0&id=fd5c2c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5c2c6c",
  null
  
)

export default component.exports